export default "__VITE_ASSET__Duu2N1kY__"